// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatRoomLayout_main__1OgJ_"};